// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#f06400","primaryColorLight":"#f97111","primaryColorLighter":"#f29f64","primaryColorLightest":"#f6cbad"};